import { useTranslation } from 'react-i18next';
import { createCheckboxField } from './createCheckboxField';

/**
 * A React component that defines and returns an array of field configurations
 * for capturing kitchen information in the form of checkboxes.
 * It makes use of the `useTranslation` hook from `react-i18next` to provide
 * translations for the label of each checkbox.
 *
 * @returns {Object} An object containing the following properties:
 * - `kitchenInformationsFields`: An array of objects, each representing a field
 *   configuration for a checkbox input capturing various kitchen appliance
 *   information. The configurations include properties such as `noLabel`,
 *   `name`, `input`, and `valuePropName`.
 *
 * @function
 * @example
 *
 * import KitchenInformations from './KitchenInformations';
 *
 * const { kitchenInformationsFields } = KitchenInformations();
 *
 * // Now, kitchenInformationsFields can be used to generate a form or part of a form
 */
const KitchenInformations = () => {
  const { t } = useTranslation();

  const kitchenInformationsFields = [
    createCheckboxField('kitchen', 'hotplate', t),
    createCheckboxField('kitchen', 'oven', t),
    createCheckboxField('kitchen', 'microwave', t),
    createCheckboxField('kitchen', 'electric_coffee_maker', t),
    createCheckboxField('kitchen', 'toaster', t),
    createCheckboxField('kitchen', 'dishwasher', t),
    createCheckboxField('kitchen', 'freezer', t)
  ];

  return {
    kitchenInformationsFields
  };
};

export default KitchenInformations;
